import { LOCAL_STORAGE_ACCESS_TOKEN, LOCAL_STORAGE_REFRESH_TOKEN } from '../../../utils/constants';
import { fetchUserInfo } from '../user/asyncThunks';
import { login, logout, refresh, resetPassword, sendCodeForNewPassword, sendVerificationCodeEmailAgain, signUp } from './asyncThunks';

export const signUpBuilder = builder => {
  builder.addCase(signUp.pending, state => {
    state.createAccountPending = true;
  });
  builder.addCase(signUp.fulfilled, (state, { payload }) => {
    const { accessToken } = payload;
    state.createAccountPending = false;
    state.loggedIn = true;
    state.token = accessToken;
  });
  builder.addCase(signUp.rejected, state => {
    state.createAccountPending = false;
  });
};

export const loginBuilder = builder => {
  builder.addCase(login.pending, state => {
    state.loginPending = true;
  });
  builder.addCase(login.fulfilled, (state, action) => {
    const { accessToken } = action.payload;
    state.loginPending = false;
    state.loggedIn = true;
    state.token = accessToken;
  });
  builder.addCase(login.rejected, state => {
    state.loginPending = false;
  });
};

export const logoutBuilder = builder => {
  builder.addCase(logout.pending, state => {
    state.loggedIn = false;
  });
  builder.addCase(logout.fulfilled, () => {
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
  });
  builder.addCase(logout.rejected, state => {
    localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
  });
};

export const refreshBuilder = builder => {
  builder.addCase(refresh.fulfilled, (state, action) => {
    const { accessToken } = action.payload;
    state.token = accessToken;
  });
};

export const fetchUserInfoBuilder = builder => {
  builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
    state.fetchUserInfoLoading = false;
    state.loggedIn = true;
  });
};

export const sendCodeForNewPasswordBuilder = builder => {
  builder.addCase(sendCodeForNewPassword.pending, state => {
    state.sendingResetEmailPending = true;
  });
  builder.addCase(sendCodeForNewPassword.fulfilled, state => {
    state.sendingResetEmailPending = false;
  });
  builder.addCase(sendCodeForNewPassword.rejected, (state, action) => {
    state.sendingResetEmailPending = false;
    state.error = action.error.message;
  });
};

export const resetPasswordBuilder = builder => {
  builder.addCase(resetPassword.pending, state => {
    state.resettingPasswordPending = true;
  });
  builder.addCase(resetPassword.fulfilled, state => {
    state.resettingPasswordPending = false;
  });
  builder.addCase(resetPassword.rejected, (state, action) => {
    state.resettingPasswordPending = false;
    state.error = action.error.message;
  });
};

export const sendVerificationCodeEmailAgainBuilder = builder => {
  builder.addCase(sendVerificationCodeEmailAgain.pending, state => {
    state.sendVerificationCodeEmailAgainPending = true;
  });
  builder.addCase(sendVerificationCodeEmailAgain.fulfilled, state => {
    state.sendVerificationCodeEmailAgainPending = false;
  });
  builder.addCase(sendVerificationCodeEmailAgain.rejected, (state, action) => {
    state.sendVerificationCodeEmailAgainPending = false;
    state.error = action.error.message;
  });
};
